import { useState, useEffect } from "react";
import { Sparkles, Briefcase, HardHat, Stethoscope, Footprints, Droplets, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardContent } from "@/components/ui/card";
import { cn } from "@/lib/utils";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [];
export default function OurServices() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="40377" id="angebote-begleitung" className="py-20 bg-background text-foreground relative overflow-hidden" ref={ref}>
      <div className="container mx-auto px-4 max-w-4xl">
        <div className={`transition-all duration-700 ease-out transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          
          
          <div className="flex flex-col gap-8">
            {services.map((service, i) => {
            const Icon = service.icon;
            const isLink = service.href && service.href !== "#";
            const CardWrapper = ({
              children,
              className
            }: {
              children: React.ReactNode;
              className?: string;
            }) => isLink ? <Link to={service.href} className={className}>
                    {children}
                  </Link> : <div className={className}>
                    {children}
                  </div>;
            return <CardWrapper key={i} data-index={i} className="group block w-full focus:outline-none">
                  <Card className={cn("w-full border border-border/40 bg-secondary/20 transition-all duration-500", "hover:border-primary/40 hover:shadow-lg hover:bg-secondary/30", "rounded-sm overflow-hidden")}>
                    <CardContent className="p-6 sm:p-8 flex flex-col sm:flex-row gap-6 items-start">
                      <div className="shrink-0 p-3 bg-background/40 rounded-full sm:bg-transparent sm:p-0">
                        <Icon className="w-8 h-8 sm:w-10 sm:h-10 text-primary opacity-80 group-hover:opacity-100 transition-opacity" strokeWidth={1.2} />
                      </div>
                      <div className="flex-1 space-y-3">
                        <div className="flex items-center justify-between gap-4">
                          <h3 className="text-2xl font-serif font-medium text-primary/90 group-hover:text-primary transition-colors">
                            {service.title}
                          </h3>
                          {isLink && <ArrowRight className="w-5 h-5 text-primary/30 group-hover:text-primary group-hover:translate-x-1 transition-all" />}
                        </div>
                        <p className="text-muted-foreground font-sans leading-relaxed text-lg">
                          {service.description}
                        </p>
                      </div>
                    </CardContent>
                  </Card>
                </CardWrapper>;
          })}
          </div>
        </div>
      </div>
    </section>;
}